import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import HelpCenterIcon from '@mui/icons-material/HelpCenter'
import { Member } from "../../services/types.ts";
import { Api } from "../../services/api.ts";
import { useAlert } from "../../contexts/alert-context.tsx";

export const ChangeRoleDialog = ({ teamId, member, open, onClose, isOwner, onRoleChanged }: {
    member: Member, onClose: () => void, open: boolean, isOwner: boolean, teamId: string, onRoleChanged: () => void
}) => {
    const alert = useAlert()
    const [role, setRole] = useState(member.role)

    const changeRole = async () => {
        try {
            await Api.changeTeamMemberRole(teamId, member.user_id, role)
            onRoleChanged()
            onClose()
        } catch (err) {
            if ([400, 403].includes(err?.response?.status)) {
                onClose()
                return alert.showAlert(err?.response?.data[0] || err?.response?.data?.detail)
            }
            throw err
        }
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Change Role</DialogTitle>
            <DialogContent>
                <Typography>
                    <p>
                        <ul>
                          <li><strong>Members</strong> can upload and delete reports for the team and create API Keys for this team to access the API (if this teams plan supports API access).</li>
                          <li><strong>Admin</strong> users inherit all member permissions, and can modify the team settings (including the name, subscription, or adding/removing members to/from the team and changing their roles), and delete reports uploaded by team memb.</li>
                          <li><strong>Owners</strong> inherit all Admin permissions and can also delete the team. There must always be one Owner of the team.</li>
                        </ul>
                    </p>
                </Typography>
                <Box marginY={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <strong>New Role</strong>
                        <Tooltip title='[REQUIRED] Choose the new role to assign to this user.'>
                            <HelpCenterIcon></HelpCenterIcon>
                        </Tooltip>
                    </Box>
                    <Select
                        style={{ flex: 'auto' }}
                        value={role}
                        label="Role"
                        sx={{ minWidth: '300px' }}
                        onChange={(e) => setRole(e.target.value)}
                    >
                        {member.role !== 'member' && <MenuItem key='member' value='member'>Member</MenuItem>}
                        {member.role !== 'admin' && <MenuItem key='admin' value='admin'>Admin</MenuItem>}
                        {member.role !== 'owner' && isOwner && <MenuItem key='owner' value='owner'>Owner</MenuItem>}
                    </Select>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={() => onClose(false)} color="primary">
                    Cancel
                </Button>
                <Button variant='contained' onClick={() => changeRole()} color="error">
                    Change Role
                </Button>
            </DialogActions>
        </Dialog>
    );
};
